@if(mode==="edit"){
@if(source !== 'enrollment'){
<div class="ppl-mt8 no-padding">
  <div class="d-flex justify-content-between align-items-start">
    <div>
      @for(header of extractValues('header'); track $index){
      <h2 tabindex="-1" pplAutoFocusHeader>{{header}}</h2>
      }
      @for(text of extractValues('text'); track $index){
      <p class="ppl-description">{{text}}</p>
      }
    </div>
    @if(canInactivateAssociation()){
    <ppl-button label="Inactivate" ariaLabel="Inactivate Association Account" [customClass]="'ghost-button'"
      (handleClick)="openInactivateConfirm()"></ppl-button>
    }
  </div>
</div>
}

<ng-template #confirmationDialog let-cancel="cancel">
  <p>Inactivating this Association Account will result in this profile no longer being available in PPL&#64;Home. Are
    you sure you want to continue?</p>
</ng-template>
<div [ngClass]="{'ppl-mt24': source !== 'enrollment'}">
  <nz-card nz-col [nzSpan]="source !== 'enrollment' ? 20 : 24" class="ppl-step-main" [nzBordered]="false">
    <form nz-form [formGroup]="infoForm" class="ppl-p0">
      @if(isAttrAvailable('businessName')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="businessName"
          class="ppl-form-label">{{getAttributes('businessName').label}}
          @if(getAttributes('businessName').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('businessName')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="businessName" id="businessName"
              placeholder="{{getAttributes('businessName').placeholder}}"
              [ngClass]="{'error': validationErrors['businessName'] }"
              [attr.aria-invalid]="validationErrors['businessName'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['businessName'] ? 'businessName-error' : null" />
          </div>
          @if (validationErrors['businessName']) {
          <span class="pl-1 error-message" id="businessName-error" role="alert">{{validationErrors['businessName']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('fname')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="fname" class="ppl-form-label">{{getAttributes('fname').label}}
          @if(getAttributes('fname').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('fname')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="fname" id="fname" placeholder="{{getAttributes('fname').placeholder}}"
              [ngClass]="{'error': validationErrors['fname'] }" 
              [attr.aria-invalid]="validationErrors['fname'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['fname'] ? 'fname-error' : null"/>
          </div>
          @if (validationErrors['fname']) {
          <span class="pl-1 error-message" id="fname-error" role="alert">{{validationErrors['fname']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('mname')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mname" class="ppl-form-label">{{getAttributes('mname').label}}
          @if(getAttributes('mname').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('mname')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="mname" id="mname" placeholder="{{getAttributes('mname').placeholder}}"
              [ngClass]="{'error': validationErrors['mname'] }"
              [attr.aria-invalid]="validationErrors['mname'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['mname'] ? 'mname-error' : null" />
          </div>
          @if (validationErrors['mname']) {
          <span class="pl-1 error-message" id="mname-error" role="alert">{{validationErrors['mname']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('lname')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="lname" class="ppl-form-label">{{getAttributes('lname').label}}
          @if(getAttributes('lname').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('lname')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="lname" id="lname" 
            [attr.aria-invalid]="validationErrors['lname'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['lname'] ? 'lname-error' : null"
            placeholder="{{getAttributes('lname').placeholder}}"
              [ngClass]="{'error': validationErrors['lname'] }" />
          </div>
          @if (validationErrors['lname']) {
          <span id="lname-error" class="pl-1 error-message" role="alert">{{validationErrors['lname']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('maiden_name')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="maiden_name"
          class="ppl-form-label">{{getAttributes('maiden_name').label}}
          @if(getAttributes('maiden_name').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('maiden_name')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="maiden_name" id="maiden_name"
              placeholder="{{getAttributes('maiden_name').placeholder}}"
              [ngClass]="{'error': validationErrors['maiden_name'] }"
              [attr.aria-invalid]="validationErrors['maiden_name'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['maiden_name'] ? 'maiden_name-error' : null" />
          </div>
          @if (validationErrors['maiden_name']) {
          <span class="pl-1 error-message" id="maiden_name-error" role="alert">{{validationErrors['maiden_name']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('dob')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="dob" class="ppl-form-label">{{getAttributes('dob').label}}
          @if(getAttributes('dob').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('dob')?.tooltip || ''" nzTooltipPlacement="topRight">
            <!-- <nz-date-picker formControlName="dob" id="dob" [nzFormat]="'MM/dd/yyyy'" [nzAllowClear]="false"
              [nzPlaceHolder]="getAttributes('dob').placeholder" [nzDisabledDate]="disabledDate"
              [ngClass]="{'error': validationErrors['dob'] }"></nz-date-picker>  -->
            <ppl-date-picker formControlName="dob" id="dob" [showIcon]="true"
              [placeholder]="getAttributes('dob').label" dateFormat="mm/dd/yy" [readonlyInput]="true"
              [monthNavigator]="true" [yearNavigator]="true" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
              inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'" [maxDate]="yesterday"
              [styleClass]="validationErrors['dob'] ? 'error' : ''"
              [ariaLabel]="getAttributes('dob').mandatory === 'Y' 
                            ? getAttributes('dob').label + ', required' 
                            : getAttributes('dob').label" [attr.aria-invalid]="validationErrors['dob'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['dob'] ? 'dob-error' : null">
            </ppl-date-picker>
          </div>
          @if (validationErrors['dob']) {
          <span id="dob-error" class="pl-1 error-message" role="alert">{{validationErrors['dob']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('gender')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="gender" class="ppl-form-label">
        <span id="gender-label" [attr.aria-label]="'Consumer' + getAttributes('gender').label">
          {{getAttributes('gender').label}}
          @if(getAttributes('gender').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </span>
      </nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('gender')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="gender" class="ppl-radio-group" id="gender" pplSelectedRadioFocus
             role="radiogroup" aria-labelledby="gender-label"
              [ngClass]="{'error': validationErrors['gender'] }" [attr.aria-invalid]="validationErrors['gender'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['gender'] ? 'gender-error' : null" >
              @for(opt of gender; track $index){
              <label nz-radio-button [nzValue]="opt.lkpValueCode">{{opt.lkpValueName}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['gender']) {
          <span class="pl-1 error-message" id="gender-error" role="alert">{{validationErrors['gender']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isProvidingServices')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="isProvidingServices" class="ppl-form-label">
          <span id="services-label" [attr.aria-label]=" getAttributes('isProvidingServices').ariaLabel">
          {{getAttributes('isProvidingServices').label}}
          @if(getAttributes('isProvidingServices').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
          </span>
        </nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isProvidingServices')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isProvidingServices" class="ppl-radio-group" id="isProvidingServices" pplSelectedRadioFocus
             role="radiogroup" aria-labelledby="services-label"
              [ngClass]="{'error': validationErrors['isProvidingServices'] }" 
              [attr.aria-label]="getAttributes('isProvidingServices')?.ariaLabel || getAttributes('isProvidingServices')?.label"
              [attr.aria-invalid]="validationErrors['isProvidingServices'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['isProvidingServices'] ? 'isProvidingServices-error' : null" >
                @for(opt of radioOptions; track $index) {
                <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                }
            </nz-radio-group>
          </div>
          @if (validationErrors['isProvidingServices']) {
          <span class="pl-1 error-message" id="isProvidingServices-error" role="alert">{{validationErrors['isProvidingServices']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }

      @if(isAttrAvailable('SSN')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="SSN" class="ppl-form-label">{{getAttributes('SSN').label}}
          @if(getAttributes('SSN').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('SSN')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-input-group [nzSuffix]="suffixTemplate" [ngClass]="{'error': validationErrors['SSN'] }">
              <input nz-input [type]="ssnVisible ? 'text' : 'password'" formControlName="SSN" id="SSN"
                placeholder="{{getAttributes('SSN').placeholder}}" (input)="limitDigits($event)" />
            </nz-input-group>
          </div>
          <ng-template #suffixTemplate>
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
           <button class="ssn-visible" type="button" [attr.aria-label]="ssnVisible ? 'Hide SSN Clickable Button' : 'Show SSN Clickable Button'" nz-icon
              [nzType]="ssnVisible ? 'eye' : 'eye-invisible'" (click)="toggleSSN()">
            </button>
         <div aria-live="polite" aria-atomic="true" class="sr-only">
           {{ liveSsnAnnouncement }}
         </div>
          </ng-template>
          @if (validationErrors['SSN']) {
          <span class="pl-1 error-message">{{validationErrors['SSN']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(ssnWith9 && flow==="employer"){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="9" [nzXs]="24" class="ppl-form-label">
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <p style="font-size:0.929rem;">Please upload ITIN documents</p>
          <ppl-upload></ppl-upload>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('CIN')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="CIN" class="ppl-form-label">{{getAttributes('CIN').label}}
          @if(getAttributes('CIN').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('CIN')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input id="CIN" formControlName="CIN" placeholder="{{getAttributes('CIN').placeholder}}"
              [ngClass]="{'error': validationErrors['CIN'] }"
              [attr.aria-invalid]="validationErrors['CIN'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['CIN'] ? 'CIN-error' : null" />
          </div>
          @if (validationErrors['CIN']) {
          <span class="pl-1 error-message" id="CIN-error" role="alert">{{validationErrors['CIN']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}

      @if(isAttrAvailable('EIN')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="EIN" class="ppl-form-label">{{getAttributes('EIN').label}}
          @if(getAttributes('EIN').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('EIN')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="EIN" id="EIN" placeholder="{{getAttributes('EIN').placeholder}}"
              [ngClass]="{'error': validationErrors['EIN'] }"
              [attr.aria-invalid]="validationErrors['EIN'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['EIN'] ? 'EIN-error' : null" />
          </div>
          @if (validationErrors['EIN']) {
          <span class="pl-1 error-message" id="EIN-error" role="alert">{{validationErrors['EIN']}}</span>
          }
          <div class="notes">
            <strong>Notes:</strong>
            <p>
              1. If EIN is lost/misplaced, then obtain your existing EIN using "<a>How to ask the IRS
                for a
                147c letter</a>".
            </p>
            <p>
              2. If EIN doesn't exist, PPL will obtain an EIN on your behalf after completion and
              submission
              of registration paperwork.
            </p>
          </div>
        </nz-form-control>
      </nz-form-item>
      }


      @if(isAttrAvailable('waiver')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="waiver" class="ppl-form-label">{{getAttributes('waiver').label}}
          @if(getAttributes('waiver').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('waiver').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['waiver'] }">
            <ppl-dropdown-select
              formControlName="waiver"
              id="waiver"
              [options]="waiver"
              [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'"
              placeholder="Select Service Administration"
              role="combobox"
              aria-required="true"
              aria-describedby="waiverError"
              [attr.aria-label]="'Select Service Administration'"
              [attr.aria-invalid]="validationErrors['waiver'] ? 'true' : 'false'">
            </ppl-dropdown-select>
          </div>

          @if (validationErrors['waiver']) {
            <span id="waiverError" class="pl-1 error-message" role="alert">
              {{validationErrors['waiver']}}
            </span>
          }


        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('ldssOffice')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="ldssOffice"
          class="ppl-form-label">{{getAttributes('ldssOffice').label}}
          @if(getAttributes('ldssOffice').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('ldssOffice').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['ldssOffice'] }">
            <ppl-dropdown-select
              formControlName="ldssOffice"
              id="ldssOffice"
              class="ppl-select"
              [options]="ldssOfficeValues"
              [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'"
              [placeholder]="flow === 'referral' && isMCOUser ? 'LDSS Office Not Applicable' : 'Select LDSS Office'"
              aria-required="true"
              aria-describedby="ldssOfficeError"
              [attr.aria-label]="flow === 'referral' && isMCOUser ? 'LDSS Office Not Applicable' : 'Select LDSS Office'"
              [attr.aria-invalid]="validationErrors['ldssOffice'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['ldssOffice']) {
              <span id="ldssOfficeError" class="pl-1 error-message" role="alert">
                {{ validationErrors['ldssOffice'] }}
              </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('mcoOrgName')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mcoOrgName"
          class="ppl-form-label">{{getAttributes('mcoOrgName').label}}
          @if(getAttributes('mcoOrgName').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('mcoOrgName').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['mcoOrgName'] }">
            <ppl-dropdown-select
              formControlName="mcoOrgName"
              id="mcoOrgName"
              class="ppl-select"
              [options]="mcoEntries"
              [optionLabel]="'orgName'"
              [optionValue]="'orgName'"
              [placeholder]="getAttributes('mcoOrgName')?.tooltip"
              aria-required="true"
              aria-describedby="mcoOrgNameError"
              [attr.aria-label]="getAttributes('mcoOrgName')?.tooltip"
              [attr.aria-invalid]="validationErrors['mcoOrgName'] ? 'true' : 'false'">
            </ppl-dropdown-select>
          </div>
            @if (validationErrors['mcoOrgName']) {
              <span id="mcoOrgNameError" class="pl-1 error-message" role="alert">
                {{ validationErrors['mcoOrgName'] }}
              </span>
            }

        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('CPI')){
        <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="CPI" class="ppl-form-label">{{getAttributes('CPI').label}}
            @if(getAttributes('CPI').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control">
            <div nz-tooltip [nzTooltipTitle]="getAttributes('CPI')?.tooltip || ''" nzTooltipPlacement="topRight">
              <input nz-input id="CPI" formControlName="CPI" placeholder="{{getAttributes('CPI').placeholder}}"
                [ngClass]="{'error': validationErrors['CPI'] }"
                [attr.aria-invalid]="validationErrors['CPI'] ? 'true' : 'false'"
                [attr.aria-describedby]="validationErrors['CPI'] ? 'CPI-error' : null" />
            </div>
            @if (validationErrors['CPI']) {
            <span class="pl-1 error-message" id="CIN-error" role="alert">{{validationErrors['CPI']}}</span>
            }
          </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('currentFI')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="currentFI"
          class="ppl-form-label">{{getAttributes('currentFI').label}}
          @if(getAttributes('currentFI').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('currentFI').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['currentFI'] }">
            <ppl-dropdown-select
              formControlName="currentFI"
              id="currentFI"
              class="ppl-select"
              [options]="currentFIValues"
              [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'"
              placeholder="Select Current FI"
              aria-required="true"
              aria-describedby="currentFIError"
              aria-label="Select Current FI"
              [attr.aria-invalid]="validationErrors['currentFI'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['currentFI']) {
              <span id="currentFIError" class="pl-1 error-message" role="alert">
                {{ validationErrors['currentFI'] }}
              </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('fiOrgName')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="fiOrgName"
          class="ppl-form-label">{{getAttributes('fiOrgName').label}}
          @if(getAttributes('fiOrgName').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('fiOrgName').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['fiOrgName'] }">
            <ppl-dropdown-select
              formControlName="fiOrgName"
              id="fiOrgName"
              class="ppl-select"
              [options]="fiEntries"
              [optionLabel]="'orgName'"
              [optionValue]="'orgName'"
              [placeholder]="getAttributes('fiOrgName')?.tooltip"
              aria-required="true"
              aria-describedby="fiOrgNameError"
              [attr.aria-label]="getAttributes('fiOrgName')?.tooltip"
              [attr.aria-invalid]="validationErrors['fiOrgName'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['fiOrgName']) {
              <span id="fiOrgNameError" class="pl-1 error-message" role="alert">
                {{ validationErrors['fiOrgName'] }}
              </span>
            }
          </div>
        </nz-form-control>
        @if(!isMobile) {
        <button type="button" class="cdpap-button" [attr.aria-label]="'Search C D PAP Facilitator, clickable'" nz-icon [nzType]="'setting'"
          (click)="openCDPAPPopup()">
        </button>
        }
      </nz-form-item>
      }
      @if(isAttrAvailable('eligiblityStartDate')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="eligiblityStartDate"
          class="ppl-form-label">{{getAttributes('eligiblityStartDate').label}}
          @if(getAttributes('eligiblityStartDate').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('eligiblityStartDate')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <!-- <nz-date-picker [nzDisabledDate]="disabledStartDate" formControlName="eligiblityStartDate"
              id="eligiblityStartDate" [nzFormat]="'MM/dd/yyyy'"
              [nzPlaceHolder]="getAttributes('eligiblityStartDate').placeholder"
              [ngClass]="{'error': validationErrors['eligiblityStartDate'] }"></nz-date-picker> -->
            <ppl-date-picker formControlName="eligiblityStartDate" [id]="'eligiblityStartDate'"  [showIcon]="true"
            dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
            [ariaLabel]="getAttributes('eligiblityStartDate').label"
            inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'"  [maxDate]="minStartDate"
            [styleClass]="validationErrors['eligiblityStartDate'] ? 'error' : ''"
            [attr.aria-invalid]="validationErrors['eligiblityStartDate'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['eligiblityStartDate'] ? 'eligiblityStartDate-error' : null">
            </ppl-date-picker>
          </div>
          @if (validationErrors['eligiblityStartDate']) {
          <span class="pl-1 error-message" id="eligiblityStartDate-error" role="alert">{{validationErrors['eligiblityStartDate']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('eligiblityEndDate')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="eligiblityEndDate"
          class="ppl-form-label">{{getAttributes('eligiblityEndDate').label}}
          @if(getAttributes('eligiblityEndDate').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('eligiblityEndDate')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <!-- <nz-date-picker formControlName="eligiblityEndDate" id="eligiblityEndDate" [nzFormat]="'MM/dd/yyyy'"
              [nzPlaceHolder]="getAttributes('eligiblityEndDate').placeholder"
              [ngClass]="{'error': validationErrors['eligiblityEndDate'] }"
              [nzDisabledDate]="disabledEndDate"></nz-date-picker> -->
            <ppl-date-picker formControlName="eligiblityEndDate" [id]="'eligiblityEndDate'"  [showIcon]="true"
            dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
            [ariaLabel]="getAttributes('eligiblityEndDate').label"
            inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'" [minDate]="maxEndDate" 
            [styleClass]="validationErrors['eligiblityEndDate'] ? 'error' : ''"
            [attr.aria-invalid]="validationErrors['eligiblityEndDate'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['eligiblityEndDate'] ? 'eligiblityEndDate-error' : null">
            </ppl-date-picker>
          </div>
          @if (validationErrors['eligiblityEndDate']) {
          <span class="pl-1 error-message" id="eligiblityEndDate-error" role="alert">{{validationErrors['eligiblityEndDate']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('relationToParticipant')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" zFor="relationToParticipant"
          class="ppl-form-label">{{getAttributes('relationToParticipant').label}}
          @if(getAttributes('relationToParticipant').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('relationToParticipant').tooltip}}" nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['relationToParticipant'] }">
            <ppl-dropdown-select
              formControlName="relationToParticipant"
              id="relationToParticipant"
              class="ppl-select"
              [options]="relationshipOptions"
              [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'"
              placeholder="Select relation to consumer"
              aria-required="true"
              aria-describedby="relationToParticipantError"
              [arialabel]="getAttributes('relationToParticipant').mandatory === 'Y' 
                ? getAttributes('relationToParticipant').label + ', required'  
                : getAttributes('relationToParticipant').label"
              [attr.aria-invalid]="validationErrors['relationToParticipant'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            </div>
            @if (validationErrors['relationToParticipant']) {
              <span id="relationToParticipantError" class="pl-1 error-message" role="alert">
                {{ validationErrors['relationToParticipant'] }}
              </span>
            }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('tempProtectedSts')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" zFor="tempProtectedSts" class="ppl-form-label">{{getAttributes('tempProtectedSts').label}}
          @if(getAttributes('tempProtectedSts').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('tempProtectedSts')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="tempProtectedSts" class="ppl-radio-group" id="tempProtectedSts" pplSelectedRadioFocus role="radiogroup"
              aria-labelledby="tempProtectedSts-label" [ngClass]="{'error': validationErrors['tempProtectedSts'] }"
              [attr.aria-label]="getAttributes('tempProtectedSts')?.ariaLabel || getAttributes('tempProtectedSts')?.label"
              [attr.aria-invalid]="validationErrors['tempProtectedSts'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['tempProtectedSts'] ? 'tempProtectedSts-error' : null">
              @for(opt of radioOptions; track $index) {
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['tempProtectedSts']) {
          <span class="pl-1 error-message" id="tempProtectedSts-error" role="alert">{{validationErrors['tempProtectedSts']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(infoForm.get('tempProtectedSts')?.value === 'Yes') {
      @if(isAttrAvailable('tpsCountryLkp')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" zFor="tpsCountryLkp" class="ppl-form-label">{{getAttributes('tpsCountryLkp').label}}
          @if(getAttributes('tpsCountryLkp').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('tpsCountryLkp').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['tpsCountryLkp'] }">
            <ppl-dropdown-select formControlName="tpsCountryLkp" id="tpsCountryLkp" class="ppl-select" [options]="tpsCountries"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" placeholder="TPS Country" [arialabel]="getAttributes('tpsCountryLkp').mandatory === 'Y' 
                          ? getAttributes('tpsCountryLkp').label + ', required'  
                          : getAttributes('tpsCountryLkp').label"
              [attr.aria-invalid]="validationErrors['tpsCountryLkp'] ? 'true' : 'false'">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['tpsCountryLkp']) {
            <span id="tpsError" class="pl-1 error-message" role="alert">
              {{ validationErrors['tpsCountryLkp'] }}
            </span>
            }
        </nz-form-control>
      </nz-form-item>
      }
      }

      @if(isAttrAvailable('showOnDirectory')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="showOnDirectory"
          class="ppl-form-label">{{getAttributes('showOnDirectory').label}}
          @if(getAttributes('showOnDirectory').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('showOnDirectory')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-radio-group [ngClass]="{'error': validationErrors['showOnDirectory'] }"
              formControlName="showOnDirectory" class="ppl-radio-group" id="showOnDirectory"
              [attr.aria-invalid]="validationErrors['showOnDirectory'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['showOnDirectory'] ? 'showOnDirectory-error' : null">
              @for(opt of radioOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['showOnDirectory']) {
          <span class="pl-1 error-message" id="showOnDirectory-error" role="alert">{{validationErrors['showOnDirectory']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('yearsInState')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="yearsInState"
          class="ppl-form-label">{{getAttributes('yearsInState').label}}
          @if(getAttributes('yearsInState').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('yearsInState').tooltip}}"
            nzTooltipPlacement="topRight" formControlName="yearsInState" id="yearsInState"
            [ngClass]="{'error': validationErrors['yearsInState'] }"
            placeholder="{{getAttributes('yearsInState').placeholder}}"
            [attr.aria-invalid]="validationErrors['yearsInState'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['yearsInState'] ? 'yearsInState-error' : null" />
          @if (validationErrors['yearsInState']) {
          <span class="pl-1 error-message" id="yearsInState-error" role="alert">{{validationErrors['yearsInState']}}</span>
          }
          <div class="notes">
            <p>
              This response may require additional background checks during enrolment.
            </p>
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('nonProfitStatus')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="nonProfitStatus"
          class="ppl-form-label">{{getAttributes('nonProfitStatus').label}}
          @if(getAttributes('nonProfitStatus').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
      </nz-form-item>
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="taxExempt"
          class="ppl-form-label">{{getAttributes('taxExempt').label}}
          @if(getAttributes('taxExempt').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
        <div [ngClass]="{ 'error': validationErrors['taxExempt'] }">
          <ppl-dropdown-select
            formControlName="taxExempt"
            id="taxExempt"
            class="ppl-select"
            [options]="taxExemptOptions"
            [optionLabel]="'lkpValueName'"
            [optionValue]="'lkpValueCode'"
            [placeholder]="getAttributes('taxExempt').placeholder"
            aria-required="true"
            aria-describedby="taxExemptError"
            aria-label="Tax Exempt"
            [attr.aria-invalid]="validationErrors['taxExempt'] ? 'true' : 'false'">
          </ppl-dropdown-select>

          @if (validationErrors['taxExempt']) {
            <span id="taxExemptError" class="pl-1 error-message" role="alert">
              {{ validationErrors['taxExempt'] }}
            </span>
          }
        </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="nprftDocumentationReceived"
          class="ppl-form-label">{{getAttributes('nprftDocumentationReceived').label}}
          @if(getAttributes('nprftDocumentationReceived').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
        <div [ngClass]="{ 'error': validationErrors['nprftDocumentationReceived'] }">
          <ppl-dropdown-select
            formControlName="nprftDocumentationReceived"
            id="nprftDocumentationReceived"
            class="ppl-select"
            [options]="[
              { lkpValueCode: 'yes', lkpValueName: 'Yes' },
              { lkpValueCode: 'no', lkpValueName: 'No' }
            ]"
            [optionLabel]="'lkpValueName'"
            [optionValue]="'lkpValueCode'"
            [placeholder]="getAttributes('nprftDocumentationReceived')?.placeholder"
            aria-required="true"
            aria-describedby="nprftDocumentationReceivedError"
            aria-label="Non-profit Documentation Received"
            [attr.aria-invalid]="validationErrors['nprftDocumentationReceived'] ? 'true' : 'false'"
            style="width: 100%; margin-bottom: 16px;">
          </ppl-dropdown-select>

          @if (validationErrors['nprftDocumentationReceived']) {
            <span id="nprftDocumentationReceivedError" class="pl-1 error-message" role="alert">
              {{ validationErrors['nprftDocumentationReceived'] }}
            </span>
          }
        </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('NPI')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="NPI" class="ppl-form-label">{{getAttributes('NPI').label}}
          @if(getAttributes('NPI').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('NPI')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="NPI" id="NPI" placeholder="{{getAttributes('NPI').placeholder}}"
              [ngClass]="{'error': validationErrors['NPI'] }" 
              [attr.aria-invalid]="validationErrors['NPI'] ? 'true' : 'false'"
            [attr.aria-describedby]="validationErrors['NPI'] ? 'NPI-error' : null"/>
          </div>
          @if (validationErrors['NPI']) {
          <span class="pl-1 error-message" id="NPI-error" role="alert">{{validationErrors['NPI']}}</span>
          }
        </nz-form-control>
      </nz-form-item>

      }
      @if(isAttrAvailable('additionalDemographics')){
      <nz-divider class="divider"></nz-divider>
      <nz-form-label [nzXs]="24" nzFor="additionalDemographics" class="ppl-form-label"
        style="margin:8px 0 24px 0;">{{getAttributes('additionalDemographics').label}}
        @if(getAttributes('additionalDemographics').mandatory === 'Y'){
        <span [attr.aria-label]="'Required'">*</span>
        }
      </nz-form-label>
      @if(isAttrAvailable('race')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="race" class="ppl-form-label">{{getAttributes('race').label}}
          @if(getAttributes('race').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('race').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['race'] }">
            <ppl-dropdown-select
              formControlName="race"
              id="race"
              class="ppl-select"
              [options]="raceOptions"
              [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'"
              placeholder="Select relation to Consumer"
              aria-required="true"
              aria-describedby="raceError"
              aria-label="Select relation to Consumer"
              [attr.aria-invalid]="validationErrors['race'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['race']) {
              <span id="raceError" class="pl-1 error-message" role="alert">
                {{ validationErrors['race'] }}
              </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }

      @if(isAttrAvailable('height')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="height" class="ppl-form-label">{{getAttributes('height').label}}
          @if(getAttributes('height').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <div nz-tooltip [nzTooltipTitle]="getAttributes('height')?.tooltip || ''" nzTooltipPlacement="topRight"
          class="height-input-container ppl-form-control">
          <input nz-input formControlName="heightFeet" id="heightFeet" placeholder="Feet"
            [ngClass]="{'error': validationErrors['heightFeet']}" />
          <span>Feet</span>
          <input nz-input formControlName="heightInches" id="heightInches" placeholder="Inches"
            [ngClass]="{'error': validationErrors['heightInches']}" />
          <span>Inches</span>
        </div>
      </nz-form-item>

      }
      @if(isAttrAvailable('weight')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="weight" class="ppl-form-label">
          {{getAttributes('weight').label}}
          @if(getAttributes('weight').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <div nz-tooltip [nzTooltipTitle]="getAttributes('weight')?.tooltip || ''" nzTooltipPlacement="topRight"
          class="weight-input-container ppl-form-control">
          <input nz-input formControlName="weight" id="weight" placeholder="{{getAttributes('weight').placeholder}}"
            [ngClass]="{'error': validationErrors['weight']}" />
          <span class="unit-label">Pounds</span>
        </div>
      </nz-form-item>
      }
      @if(isAttrAvailable('eyeColor')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="eyeColor"
          class="ppl-form-label">{{getAttributes('eyeColor').label}}
          @if(getAttributes('eyeColor').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('eyeColor').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['eyeColor'] }">
            <ppl-dropdown-select
              formControlName="eyeColor"
              id="eyeColor"
              class="ppl-select"
              [options]="eyeColors"
              [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'"
              placeholder="Select Eye Color"
              aria-required="true"
              aria-describedby="eyeColorError"
              aria-label="Select Eye Color"
              [attr.aria-invalid]="validationErrors['eyeColor'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['eyeColor']) {
              <span id="eyeColorError" class="pl-1 error-message" role="alert">
                {{ validationErrors['eyeColor'] }}
              </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('hairColor')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="hairColor"
          class="ppl-form-label">{{getAttributes('hairColor').label}}
          @if(getAttributes('hairColor').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('hairColor').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['hairColor'] }">
            <ppl-dropdown-select
              formControlName="hairColor"
              id="hairColor"
              class="ppl-select"
              [options]="hairColors"
              [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'"
              placeholder="Select Hair Color"
              aria-required="true"
              aria-describedby="hairColorError"
              aria-label="Select Hair Color"
              [attr.aria-invalid]="validationErrors['hairColor'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['hairColor']) {
              <span id="hairColorError" class="pl-1 error-message" role="alert">
                {{ validationErrors['hairColor'] }}
              </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('birthPlace')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="birthPlace"
          class="ppl-form-label">{{getAttributes('birthPlace').label}}
          @if(getAttributes('birthPlace').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
            <input nz-input formControlName="birthCity" id="birthCity" placeholder="City" />
          </div>
        </nz-form-control>
        <nz-form-control class="ppl-form-control" style="margin: 0px 4px;">
          <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
            <input nz-input formControlName="birthState" id="birthState" placeholder="State" />
          </div>
        </nz-form-control>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
            <input nz-input formControlName="birthCountry" id="birthCountry" placeholder="Country" />
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      <nz-divider class="divider"></nz-divider>
      }
      @if(isAttrAvailable('addToED')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="addToED" class="ppl-form-label">{{getAttributes('addToED').label}}
          @if(getAttributes('addToED').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('addToED')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="addToED" class="ppl-radio-group" id="addToED"
              [ngClass]="{'error': validationErrors['addToED'] }"
              [attr.aria-invalid]="validationErrors['addToED'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['addToED'] ? 'addToED-error' : null">
              @for(opt of radioOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['addToED']) {
          <span class="pl-1 error-message" id="addToED-error" role="alert">{{validationErrors['addToED']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}

      @if(isAttrAvailable('servicesRendered')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="servicesRendered"
          class="ppl-form-label">{{getAttributes('servicesRendered').label}}
          @if(getAttributes('servicesRendered').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div [ngClass]="{'error': validationErrors['servicesRendered'] }">
            <ppl-multiselect formControlName="servicesRendered" id="servicesRendered" [options]="services" style="width:100%; margin-bottom: 16px"
              [showClear]="true" placeholder="{{getAttributes('servicesRendered').placeholder}}" [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'" [disabled]="false" [maxTagCount]="4" style="width:100%; margin-bottom: 16px"
              [attr.aria-invalid]="validationErrors['servicesRendered'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['servicesRendered'] ? 'servicesRendered-error' : null">
            </ppl-multiselect>
          </div>
          @if (validationErrors['servicesRendered']) {
            <span class="pl-1 error-message" id="servicesRendered-error" role="alert">{{validationErrors['servicesRendered']}}</span>
          }

        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('applicationSource') && !fromInterest){
        <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="applicationSource" class="ppl-form-label">{{getAttributes('applicationSource').label}}
            @if(getAttributes('applicationSource').mandatory === 'Y'){
            <span [attr.aria-label]="'Required'">*</span>
            }</nz-form-label>
          <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('applicationSource').tooltip}}"
            nzTooltipPlacement="topRight">
            @if(isApplicationSourceFixed) {
              <input nz-input
                id="applicationSource"
                [value]="getApplicationSourceDisplayValue()"
                [disabled]="true"
                [attr.aria-label]="getAttributes('applicationSource')?.label"/>
            } @else {
              <div [ngClass]="{ 'error': validationErrors['applicationSource'] }">
                <ppl-dropdown-select
                  formControlName="applicationSource"
                  id="applicationSource"
                  class="ppl-select"
                  [options]="applicationSourceList"
                  [optionLabel]="'lkpValueName'"
                  [optionValue]="'lkpValueCode'"
                  [placeholder]="getAttributes('applicationSource')?.placeholder"
                  aria-required="true"
                  aria-describedby="applicationSourceError"
                  [attr.aria-label]="getAttributes('applicationSource')?.placeholder"
                  [attr.aria-invalid]="validationErrors['applicationSource'] ? 'true' : 'false'">
                </ppl-dropdown-select>
              </div>
              @if (validationErrors['applicationSource']) {
                <span id="applicationSourceError" class="pl-1 error-message" role="alert">
                  {{ validationErrors['applicationSource'] }}
                </span>
              }
            }
          </nz-form-control>
        </nz-form-item>
        }
        @if(isAttrAvailable('contactStsReasonLkp')){
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactStsReasonLkp" class="ppl-form-label">{{getAttributes('contactStsReasonLkp').label}}
              @if(getAttributes('contactStsReasonLkp').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }</nz-form-label>
            <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('contactStsReasonLkp').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{ 'error': validationErrors['contactStsReasonLkp'] }">
                <ppl-dropdown-select
                  formControlName="contactStsReasonLkp"
                  id="contactStsReasonLkp"
                  class="ppl-select"
                  [options]="contactStsReasonLkpList"
                  [optionLabel]="'lkpValueName'"
                  [optionValue]="'lkpValueCode'"
                  [placeholder]="getAttributes('contactStsReasonLkp')?.placeholder"
                  aria-required="true"
                  aria-describedby="contactStsReasonLkpError"
                  [attr.aria-label]="getAttributes('contactStsReasonLkp')?.placeholder"
                  [attr.aria-invalid]="validationErrors['contactStsReasonLkp'] ? 'true' : 'false'">
                </ppl-dropdown-select>

                @if (validationErrors['contactStsReasonLkp']) {
                  <span id="contactStsReasonLkpError" class="pl-1 error-message" role="alert">
                    {{ validationErrors['contactStsReasonLkp'] }}
                  </span>
                }
              </div>
            </nz-form-control>
          </nz-form-item>
          }
          @if(isAttrAvailable('contactStsComments')){
            <nz-form-item class="ppl-form-item">
              <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactStsComments"
                class="ppl-form-label">{{getAttributes('contactStsComments').label}}
                @if(getAttributes('contactStsComments').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }
              </nz-form-label>
              <nz-form-control class="ppl-form-control">
                <div nz-tooltip [nzTooltipTitle]="getAttributes('contactStsComments')?.tooltip || ''" nzTooltipPlacement="topRight">
                  <nz-textarea-count [nzMaxCharacterCount]="300">
                  <textarea rows="4" cols="40" nz-input formControlName="contactStsComments" id="contactStsComments"
                  class="ppl-form-control" placeholder="{{getAttributes('contactStsComments').placeholder}}"
                  [ngClass]="{'error': validationErrors['contactStsComments'] }" [maxlength]="300"
                  [attr.aria-invalid]="validationErrors['contactStsComments'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['contactStsComments'] ? 'contactStsComments-error' : null"></textarea>
                </nz-textarea-count>
                </div>
                @if (validationErrors['contactStsComments']) {
                <span class="pl-1 error-message" id="contactStsComments-error" role="alert">{{validationErrors['contactStsComments']}}</span>
                }
              </nz-form-control>
            </nz-form-item>
          }
      @if(isAttrAvailable('prospectiveDR') && flow === 'referral'){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="prospectiveDR"
          class="ppl-form-label">{{getAttributes('prospectiveDR').label}}
          @if(getAttributes('prospectiveDR').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div class="height-input-container pdr-input-container" nz-tooltip [nzTooltipTitle]="getAttributes('prospectiveDR')?.tooltip || ''" nzTooltipPlacement="topRight">
            <div style="flex: 1;">
              <input nz-input formControlName="pdrFirstName" id="pdrFirstName" placeholder="First Name"
                [ngClass]="{'error': validationErrors['pdrFirstName'] }"
                [attr.aria-invalid]="validationErrors['pdrFirstName'] ? 'true' : 'false'"
                [attr.aria-describedby]="validationErrors['pdrFirstName'] ? 'pdrFirstName-error' : null" />
              @if (validationErrors['pdrFirstName']) {
              <span class="pl-1 error-message" id="pdrFirstName-error" role="alert">{{validationErrors['pdrFirstName']}}</span>
              }
            </div>
            <div style="flex: 1;">
              <input nz-input formControlName="pdrLastName" id="pdrLastName" placeholder="Last Name"
                [ngClass]="{'error': validationErrors['pdrLastName'] }"
                [attr.aria-invalid]="validationErrors['pdrLastName'] ? 'true' : 'false'"
                [attr.aria-describedby]="validationErrors['pdrLastName'] ? 'pdrLastName-error' : null" />
              @if (validationErrors['pdrLastName']) {
              <span class="pl-1 error-message" id="pdrLastName-error" role="alert">{{validationErrors['pdrLastName']}}</span>
              }
            </div>
            <div style="flex: 1;" [ngClass]="{ 'error': validationErrors['pdrRelation'] }">
              <ppl-dropdown-select
                formControlName="pdrRelation"
                id="pdrRelation"
                class="ppl-select"
                [options]="relationshipOptions"
                [optionLabel]="'lkpValueName'"
                [optionValue]="'lkpValueCode'"
                placeholder="Relationship"
                aria-describedby="pdrRelationError"
                [attr.aria-label]="'Relationship'"
                [attr.aria-invalid]="validationErrors['pdrRelation'] ? 'true' : 'false'">
              </ppl-dropdown-select>
              @if (validationErrors['pdrRelation']) {
                <span id="pdrRelationError" class="pl-1 error-message" role="alert">
                  {{ validationErrors['pdrRelation'] }}
                </span>
              }
            </div>
            <div style="flex: 1;">
              <input nz-input formControlName="pdrPhone" id="pdrPhone" placeholder="Phone Number" maxlength="10"
                [ngClass]="{'error': validationErrors['pdrPhone'] }" [attr.aria-label]="'Phone Number'"
                [attr.aria-invalid]="validationErrors['pdrPhone'] ? 'true' : 'false'"
                [attr.aria-describedby]="validationErrors['pdrPhone'] ? 'pdrPhone-error' : null" />
              @if (validationErrors['pdrPhone']) {
              <span class="pl-1 error-message" id="pdrPhone-error" role="alert">{{validationErrors['pdrPhone']}}</span>
              }
            </div>
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('prospectiveDR') && flow !== 'referral' && flow !== 'participantEnrollment'){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="prospectiveDR"
          class="ppl-form-label">{{getAttributes('prospectiveDR').label}}</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <span>{{ getProspectiveDRDisplayValue(infoForm.value) }}</span>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('isSnapReceived')){
      <h4 class="additional-demo-header" style="margin-bottom: 24px;">Additional Demographics</h4>
      <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isSnapReceived" class="ppl-form-label">
            <span id="isSnapReceived-label" [attr.aria-label]="getAttributes('isSnapReceived').label">
              {{getAttributes('isSnapReceived').label}}
              @if(getAttributes('isSnapReceived').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }
            </span>
          </nz-form-label>
        <nz-form-control [nzSm]="8" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isSnapReceived')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isSnapReceived" class="ppl-radio-group" id="isSnapReceived" pplSelectedRadioFocus
             role="radiogroup" aria-labelledby="isSnapReceived-label"
              [ngClass]="{'error': validationErrors['isSnapReceived'] }" [attr.aria-invalid]="validationErrors['isSnapReceived'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['isSnapReceived'] ? 'isSnapReceived-error' : null" >
              @for(opt of radioBooleanOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isSnapReceived']) {
          <span class="pl-1 error-message" id="isSnapReceived-error" role="alert">{{validationErrors['isSnapReceived']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isTanfReceived')){
      <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isTanfReceived" class="ppl-form-label">
            <span id="isTanfReceived-label" [attr.aria-label]="getAttributes('isTanfReceived').label">
              {{getAttributes('isTanfReceived').label}}
              @if(getAttributes('isTanfReceived').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }
            </span>
          </nz-form-label>
        <nz-form-control [nzSm]="8" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isTanfReceived')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isTanfReceived" class="ppl-radio-group" id="isTanfReceived" pplSelectedRadioFocus
             role="radiogroup" aria-labelledby="isTanfReceived-label"
              [ngClass]="{'error': validationErrors['isTanfReceived'] }" [attr.aria-invalid]="validationErrors['isTanfReceived'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['isTanfReceived'] ? 'isTanfReceived-error' : null" >
              @for(opt of radioBooleanOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isTanfReceived']) {
          <span class="pl-1 error-message" id="isTanfReceived-error" role="alert">{{validationErrors['isTanfReceived']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isSsiReceived')){
      <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isSsiReceived" class="ppl-form-label">
            <span id="isSsiReceived-label" [attr.aria-label]="getAttributes('isSsiReceived').label">
              {{getAttributes('isSsiReceived').label}}
              @if(getAttributes('isSsiReceived').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }
            </span>
          </nz-form-label>
        <nz-form-control [nzSm]="8" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isSsiReceived')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isSsiReceived" class="ppl-radio-group" id="isSsiReceived" pplSelectedRadioFocus
             role="radiogroup" aria-labelledby="isSsiReceived-label"
              [ngClass]="{'error': validationErrors['isSsiReceived'] }" [attr.aria-invalid]="validationErrors['isSsiReceived'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['isSsiReceived'] ? 'isSsiReceived-error' : null" >
              @for(opt of radioBooleanOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isSsiReceived']) {
          <span class="pl-1 error-message" id="isSsiReceived-error" role="alert">{{validationErrors['isSsiReceived']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isUnemployed')){
      <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isUnemployed" class="ppl-form-label">
            <span id="isUnemployed-label" [attr.aria-label]="getAttributes('isUnemployed').label">
              {{getAttributes('isUnemployed').label}}
              @if(getAttributes('isUnemployed').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }
            </span>
          </nz-form-label>
        <nz-form-control [nzSm]="8" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isUnemployed')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isUnemployed" class="ppl-radio-group" id="isUnemployed" pplSelectedRadioFocus
             role="radiogroup" aria-labelledby="isUnemployed-label"
              [ngClass]="{'error': validationErrors['isUnemployed'] }" [attr.aria-invalid]="validationErrors['isUnemployed'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['isUnemployed'] ? 'isUnemployed-error' : null" >
              @for(opt of radioBooleanOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isUnemployed']) {
          <span class="pl-1 error-message" id="isUnemployed-error" role="alert">{{validationErrors['isUnemployed']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isVeteran')){
      <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isVeteran" class="ppl-form-label">
            <span id="isVeteran-label" [attr.aria-label]="getAttributes('isVeteran').label">
              {{getAttributes('isVeteran').label}}
              @if(getAttributes('isVeteran').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }
            </span>
          </nz-form-label>
        <nz-form-control [nzSm]="8" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isVeteran')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isVeteran" class="ppl-radio-group" id="isVeteran" pplSelectedRadioFocus
             role="radiogroup" aria-labelledby="isVeteran-label"
              [ngClass]="{'error': validationErrors['isVeteran'] }" [attr.aria-invalid]="validationErrors['isVeteran'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['isVeteran'] ? 'isVeteran-error' : null" >
              @for(opt of radioBooleanOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isVeteran']) {
          <span class="pl-1 error-message" id="isVeteran-error" role="alert">{{validationErrors['isVeteran']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isDisabilityComp') && infoForm.get('isVeteran')?.value){
      <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isDisabilityComp" class="ppl-form-label">
            <span id="isDisabilityComp-label" [attr.aria-label]="getAttributes('isDisabilityComp').label">
              {{getAttributes('isDisabilityComp').label}}
              @if(getAttributes('isDisabilityComp').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }
            </span>
          </nz-form-label>
        <nz-form-control [nzSm]="8" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isDisabilityComp')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isDisabilityComp" class="ppl-radio-group" id="isDisabilityComp" pplSelectedRadioFocus
             role="radiogroup" aria-labelledby="isDisabilityComp-label"
              [ngClass]="{'error': validationErrors['isDisabilityComp'] }" [attr.aria-invalid]="validationErrors['isDisabilityComp'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['isDisabilityComp'] ? 'isDisabilityComp-error' : null" >
              @for(opt of radioBooleanOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isDisabilityComp']) {
          <span class="pl-1 error-message" id="isDisabilityComp-error" role="alert">{{validationErrors['isDisabilityComp']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isWotcCertified')){
      <nz-form-item class="ppl-form-item">
          <nz-form-control class="ppl-form-control">
            <input nz-input type="checkbox" class="checkbox" formControlName="isWotcCertified"/> 
            <span style="margin-left: 8px; font-weight: 600;">{{getAttributes('isWotcCertified').label}}</span>
            <p>
              <span *ngIf="validationErrors['isWotcCertified']" class="pl-1 error-message">
                {{validationErrors['isWotcCertified']}}
              </span>
            </p>
          </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('prospectiveDR') && flow === 'participantEnrollment'){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="prospectiveDR"
          class="ppl-form-label">{{getAttributes('prospectiveDR').label}}</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div class="height-input-container" nz-tooltip [nzTooltipTitle]="getAttributes('prospectiveDR')?.tooltip || ''" nzTooltipPlacement="topRight">
            <div style="flex: 1;">
              <input nz-input id="pdrFirstName" [value]="infoForm.get('pdrFirstName')?.value" [disabled]="true"
                placeholder="First Name" [attr.aria-label]="'First Name'" />
            </div>
            <div style="flex: 1;">
              <input nz-input id="pdrLastName" [value]="infoForm.get('pdrLastName')?.value" [disabled]="true"
                placeholder="Last Name" [attr.aria-label]="'Last Name'" />
            </div>
            <div style="flex: 1;">
              <ppl-dropdown-select
                id="pdrRelation"
                class="ppl-select"
                [options]="relationshipOptions"
                [optionLabel]="'lkpValueName'"
                [optionValue]="'lkpValueCode'"
                [ngModel]="infoForm.get('pdrRelation')?.value"
                [ngModelOptions]="{standalone: true}"
                placeholder="Relationship"
                [attr.aria-label]="'Relationship'"
                [disabled]="true">
              </ppl-dropdown-select>
            </div>
            <div style="flex: 1;">
              <input nz-input id="pdrPhone" [value]="infoForm.get('pdrPhone')?.value" [disabled]="true"
                placeholder="Phone Number" [attr.aria-label]="'Phone Number'" />
            </div>
          </div>
        </nz-form-control>
      </nz-form-item>
      }
    </form>
    @if((flow === 'providerEnrollment' || flow === 'participantEnrollment') && isPageAccessLoaded){
    <div class="login-details-section" [hidden]="!hasLoginData" *authorize="[pageId, tabId, 'Usernames', 'section']">
      <h4 class="additional-demo-header" style="margin: 24px 0 16px 0;">Login Details</h4>
      <ppl-login-details [entry]="flow" [program]="program" [readOnly]="formReadonly" [displayMode]="'card'"
        [selectedLeadId]="selectedLead" (hasData)="hasLoginData = $event" (loginDataChange)="loginRecords = $event"
        [pageId]="pageId" [tabId]="tabId"></ppl-login-details>
    </div>
    }
  </nz-card>
</div>}
@else if(mode==="read"){
  <div tabindex="0">
@if(isAttrAvailable('businessName')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{ getAttributes('businessName').label }} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['businessName']}}
    </span>
    <span *ngIf="!filledInfo['businessName']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('fname')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{ getAttributes('fname').label }} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['fname']}}
    </span>
    <span *ngIf="!filledInfo['fname']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('mname')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('mname').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['mname']}}
    </span>
    <span *ngIf="!filledInfo['mname']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('lname')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('lname').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['lname']}}
    </span>
    <span *ngIf="!filledInfo['lname']" class="sr-only">Blank</span>
    </div>
</div>
}
@if(isAttrAvailable('maiden_name')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('maiden_name').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['maiden_name']}}
    </span>
    <span *ngIf="!filledInfo['maiden_name']" class="sr-only">Blank</span>
</div>
</div>
}
@if(isAttrAvailable('dob')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('dob').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['dob']}}
    </span>
    <span *ngIf="!filledInfo['dob']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('gender')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('gender').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{(getLookupValue(gender, filledInfo['gender']))}}
    </span>
    <span *ngIf="!filledInfo['gender']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('state') && this.state){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{ getAttributes('state').label }} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ (getLookupValue(states, this.state))}}
    </span>
    <span *ngIf="!this.state" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('isProvidingServices')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('isProvidingServices').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['isProvidingServices'] }}
    </span>
    <span *ngIf="!filledInfo['isProvidingServices']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('SSN')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('SSN').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['SSN'] }}
    </span>
    <span *ngIf="!filledInfo['SSN']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('CIN')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('CIN').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['CIN'] }}
    </span>
    <span *ngIf="!filledInfo['CIN']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('EIN')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('EIN').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['EIN'] }}
    </span>
    <span *ngIf="!filledInfo['EIN']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('waiver')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('waiver').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ getLookupValue(waiver, filledInfo['waiver']) }}
    </span>
    <span *ngIf="!filledInfo['waiver']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('ldssOffice')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('ldssOffice').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ flow === 'referral' && isMCOUser ? 'Not Applicable' : getLookupValue(ldssOfficeValues, filledInfo['ldssOffice']) }}
    </span>
    <span *ngIf="!filledInfo['ldssOffice'] && !(flow === 'referral' && isMCOUser)" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('mcoOrgName')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('mcoOrgName').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['mcoOrgName'] }}
    </span>
    <span *ngIf="!filledInfo['mcoOrgName']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('CPI')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('CPI').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['CPI'] }}
      </span>
      <span *ngIf="!filledInfo['CPI']" class="sr-only">Blank</span>
    </div>
  </div>
}
@if(isAttrAvailable('currentFI')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('currentFI').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ getLookupValue(currentFIValues, filledInfo['currentFI']) }}
    </span>
    <span *ngIf="!filledInfo['currentFI']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('fiOrgName')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('fiOrgName').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['fiOrgName'] }}
    </span>
    <span *ngIf="!filledInfo['fiOrgName']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('eligiblityStartDate')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('eligiblityStartDate').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['eligiblityStartDate'] }}
    </span>
    <span *ngIf="!filledInfo['eligiblityStartDate']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('eligiblityEndDate')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('eligiblityEndDate').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['eligiblityEndDate'] }}
    </span>
    <span *ngIf="!filledInfo['eligiblityEndDate']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('relationToParticipant')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('relationToParticipant').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo.relationToParticipant ? getLookupValue(relationshipOptions,
    filledInfo['relationToParticipant']) : filledInfo.relationToParticipant}}
    </span>
    <span *ngIf="!filledInfo['relationToParticipant']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('tempProtectedSts')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('tempProtectedSts').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo.tempProtectedSts }}
    </span>
    <span *ngIf="!filledInfo['relationToParticipant']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(infoForm.get('tempProtectedSts')?.value === 'Yes') {
  @if(isAttrAvailable('tpsCountryLkp')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('tpsCountryLkp').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo.tpsCountryLkp ? getLookupValue(tpsCountries,
        filledInfo['tpsCountryLkp']) : filledInfo.tpsCountryLkp}}
      </span>
      <span *ngIf="!filledInfo['tpsCountryLkp']" class="sr-only">Blank</span>
    </div>
  </div>
  }
}
@if(isAttrAvailable('showOnDirectory')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('showOnDirectory').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['showOnDirectory']}}
    </span>
    <span *ngIf="!filledInfo['showOnDirectory']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('yearsInState')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('yearsInState').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['yearsInState']}}
    </span>
    <span *ngIf="!filledInfo['yearsInState']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('nonProfitStatus')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('nonProfitStatus').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['nonProfitStatus']}}
    </span>
    <span *ngIf="!filledInfo['nonProfitStatus']" class="sr-only">Blank</span>
  </div>
</div>
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('taxExempt').label}} :</div>
   <div nz-col nzSpan="16">
    <span>
      {{ filledInfo.taxExempt ? getLookupValue(taxExemptOptions, filledInfo['taxExempt']) :
    filledInfo.taxExempt}}
    </span>
    <span *ngIf="!filledInfo['taxExempt']" class="sr-only">Blank</span>
  </div>
</div>
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('nprftDocumentationReceived').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['nprftDocumentationReceived']}}
    </span>
    <span *ngIf="!filledInfo['nprftDocumentationReceived']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('NPI')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('NPI').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['NPI']}}
    </span>
    <span *ngIf="!filledInfo['NPI']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('servicesRendered')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{ getAttributes('servicesRendered').label }} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ getLookupValue(services, filledInfo['servicesRendered'])}}
    </span>
    <span *ngIf="!filledInfo['servicesRendered']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('applicationSource') && !fromInterest){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('applicationSource').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ getLookupValue(applicationSourceList, filledInfo['applicationSource']) || filledInfo['applicationSource'] }}
      </span>
      <span *ngIf="!filledInfo['applicationSource']" class="sr-only">Blank</span>
    </div>
  </div>
  }
  @if(isAttrAvailable('contactStsReasonLkp')){
    <div nz-row>
      <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('contactStsReasonLkp').label}} :</div>
      <div nz-col nzSpan="16">
        <span>
          {{ getLookupValue(contactStsReasonLkpList, filledInfo['contactStsReasonLkp']) }}
        </span>
        <span *ngIf="!filledInfo['contactStsReasonLkp']" class="sr-only">Blank</span>
      </div>
    </div>
  }
  @if(isAttrAvailable('contactStsComments')){
    <div nz-row>
      <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('contactStsComments').label}} :</div>
      <div nz-col nzSpan="16">
        <span>
          {{ filledInfo['contactStsComments'] }}
        </span>
        <span *ngIf="!filledInfo['contactStsComments']" class="sr-only">Blank</span>
      </div>
    </div>
  }
  @if(isAttrAvailable('prospectiveDR')){
  <div nz-row>
    <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('prospectiveDR').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ getProspectiveDRDisplayValue(filledInfo) }}
      </span>
      <span *ngIf="!getProspectiveDRDisplayValue(filledInfo)" class="sr-only">Blank</span>
    </div>
  </div>
  }
@if(isAttrAvailable('additionalDemographics')){
<div nz-row class="ppl-read-label">Additional Demographics :</div>
@if(isAttrAvailable('race')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('race').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo.race ? getLookupValue(raceOptions, filledInfo['race']) : filledInfo.race}}
    </span>
    <span *ngIf="!filledInfo['race']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('height')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('height').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['heightFeet']}} Feet {{ filledInfo['heightInches'] || 0}} Inches
    </span>
    <span *ngIf="!filledInfo['heightInches']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('weight')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('weight').label}} :</div>
  <div nz-col nzSpan="16">
    <span>
      {{ filledInfo['weight']}} Pounds
    </span>
    <span *ngIf="!filledInfo['weight']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('eyeColor')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('eyeColor').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo.eyeColor ? getLookupValue(eyeColors, filledInfo['eyeColor']) :
    filledInfo.eyeColor}}
      </span>
      <span *ngIf="!filledInfo['eyeColor']" class="sr-only">Blank</span>
    </div>
</div>
}
@if(isAttrAvailable('hairColor')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('hairColor').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo.hairColor ? getLookupValue(hairColors, filledInfo['hairColor']) :
    filledInfo.hairColor}}
      </span>
      <span *ngIf="!filledInfo['hairColor']" class="sr-only">Blank</span>
    </div>
</div>
}
@if(isAttrAvailable('birthPlace')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('birthPlace').label}} :</div>
    <div nz-col nzSpan="16">
      <span>
        {{ filledInfo['birthCity']}} {{ filledInfo['birthState']}} {{ filledInfo['birthCountry']}}
      </span>
      <span *ngIf="!filledInfo['birthCity']" class="sr-only">Blank</span>
  </div>
</div>
}
}
@if(isAttrAvailable('isSnapReceived')){
<h5 class="additional-demo-header" style="margin: 16px 0;">Additional Demographics :</h5>
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isSnapReceived').label}}</div>
  <div nz-col nzSpan="8">
    <span>
      {{ getBooleanLabel(filledInfo['isSnapReceived']) }}
    </span>
    <span *ngIf="!filledInfo['isSnapReceived']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('isTanfReceived')){
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isTanfReceived').label}}</div>
  <div nz-col nzSpan="8">
    <span>
      {{ getBooleanLabel(filledInfo['isTanfReceived']) }}
    </span>
    <span *ngIf="!filledInfo['isTanfReceived']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('isSsiReceived')){
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isSsiReceived').label}}</div>
  <div nz-col nzSpan="8">
    <span>
      {{ getBooleanLabel(filledInfo['isSsiReceived']) }}
    </span>
    <span *ngIf="!filledInfo['isSsiReceived']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('isUnemployed')){
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isUnemployed').label}}</div>
  <div nz-col nzSpan="8">
    <span>
      {{ getBooleanLabel(filledInfo['isUnemployed']) }}
    </span>
    <span *ngIf="!filledInfo['isUnemployed']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('isVeteran')){
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isVeteran').label}}</div>
  <div nz-col nzSpan="8">
    <span>
      {{ getBooleanLabel(filledInfo['isVeteran']) }}
    </span>
    <span *ngIf="!filledInfo['isVeteran']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('isDisabilityComp') && infoForm.get('isVeteran')?.value){
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isDisabilityComp').label}}</div>
  <div nz-col nzSpan="8">
    <span>
      {{ getBooleanLabel(filledInfo['isDisabilityComp']) }}
    </span>
    <span *ngIf="!filledInfo['isDisabilityComp']" class="sr-only">Blank</span>
  </div>
</div>
}
@if(isAttrAvailable('isWotcCertified')){
  <div nz-row>
    <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isWotcCertified').label}} :</div>
    <div nz-col nzSpan="8">
      <span>
        {{ getBooleanLabel(filledInfo['isWotcCertified']) }}
      </span>
      <span *ngIf="!filledInfo['isWotcCertified']" class="sr-only">Blank</span>
    </div>
  </div>
}
</div>

}